module.exports = __webpack_public_path__ + "static/media/camiseta.f012189e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/camiseta.jpg
// module id = 1290
// module chunks = 0